import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const FollowNubank = styled.div`
  ul {
    display: flex;
    flex-wrap: wrap;
  }

  li {
    margin-right: ${themeSpace(2)};
  }

  li:last-child {
    margin-right: 0;
  }
`;

FollowNubank.displayName = 'FollowNubank';
